export default "__VITE_ASSET__CWAnYwPd__"